<app-header></app-header>
<app-lateral-buttons></app-lateral-buttons>
<!--====================================================
                       HOME-P
======================================================-->
<div id="home-p" class="text-center">
  <a target="_blank" href="https://www.merquellantas.com/">
    <img src="assets/img/merque1.jpg" class="img-fluid" alt="..." />
  </a>
</div>
<div class="container merque" style="align-items: center;">
  <h3>CONTÁCTANOS</h3>
  <ul class="contacto">
    <li class="fa fa-phone fa-3x"><span>(+571) 7868540</span></li>
    <li class="fa fa-whatsapp fa-3x"><span>(+57) 317 6379904</span></li>
  </ul>
</div>
<!--====================================================
                  BUSINESS-GROWTH-P1
======================================================-->
<section id="business-growth-p1" class="business-growth-p1 bg-gray">
  <div class="container">
    <div class="row title-bar">
      <div class="col-md-12">
        <h1 class="wow fadeInUp">MERQUELLANTAS</h1>
        <div class="heading-border"></div>
        <p class="wow fadeInUp" data-wow-delay="0.4s" >
          Somos un comercializador de llantas, servicio de reencauche,
          lubricantes y todo lo que su vehículo necesita, contamos con más de 27
          años de experiencia en el mercado colombiano, destacándonos como una
          compañía líder en el mercado colombiano.
        </p>
        <p class="wow fadeInUp" data-wow-delay="0.4s">
          Contamos con una red de servicio a nivel nacional con más de 22 puntos
          en todo el territorio que nos permite brindarle una solución a su
          medida y lo mejor tenemos diferentes formas de pago, desde contando
          hasta plazos superiores a 12 meses.
        </p>
      </div>
    </div>
    <div class="row wow animated fadeInUp" data-wow-duration="1s" data-wow-delay="0.5s">
      <div class="col-md-4 col-sm-6 service-padding">
        <div class="service-item">
          <div class="service-item-icon">
            <i class="fa fa-life-ring fa-3x"></i>
          </div>
          <div class="service-item-title">
            <h3>Llantas</h3>
          </div>
          <div class="service-item-desc">
            <p>
              Nos especializamos en todo tipo de llantas, permítenos cambiar el
              camino de tu vehículo
            </p>
            <div class="content-title-underline-light"></div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-6 service-padding">
        <div class="service-item">
          <div class="service-item-icon"><i class="fa fa-tint fa-3x"></i></div>
          <div class="service-item-title">
            <h3>Lubricantes</h3>
          </div>
          <div class="service-item-desc">
            <p>
              El lubricante es esencial para el correcto funcionamiento de tu
              vehículo.
            </p>
            <div class="content-title-underline-light"></div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-6 service-padding">
        <div class="service-item">
          <div class="service-item-icon"><i class="fa fa-car fa-3x"></i></div>
          <div class="service-item-title">
            <h3>Accesorios</h3>
          </div>
          <div class="service-item-desc">
            <p>Te brindamos los lujos y accesorios para tu vehículo.</p>
            <div class="content-title-underline-light"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--====================================================
                FINANCIAL-P1
======================================================-->
<section id="financial-p1" class="bg-parallax financial-p3-bg">
  <div class="overlay-financial-p1"></div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-6 financial-p1-pos">
        <div class="financial-p1-cont">
          <!--<a href="#"> <b>Richtech Technology</b></a> -->
          <h3>Merquellantas en Rueda Verde</h3>
          <p>
            El primer programa posconsumo de llantas. Rueda Verde es una entidad
            sin ánimo de lucro que desarrolla un sistema sostenible de
            recolección selectiva y gestión ambiental de llantas usadas, con el
            propósito de prevenir y controlar la degradación del ambiente, de
            conformidad con la regulación colombiana vigente. Rueda Verde se
            consolidará en 2024 como el sistema de recolección selectiva y
            gestión ambiental de llantas usadas líder en Colombia, garantizando
            el cumplimiento de la legislación ambiental vigente, planificando
            acciones para: alcanzar las metas de recolección y gestión
            establecidas, incrementar la cobertura geográfica y fortalecer los
            mecanismos de comunicación al ciudadano.
          </p>
          <!--<button class="btn btn-general btn-white" role="button">
            Contact Us
          </button> -->
        </div>
      </div>
      <div class="col-md-6 financial-p1-emp-img"></div>
    </div>
  </div>
</section>
<section id="financial-p1" class="bg-parallax financial-p2-bg">
  <div class="overlay-financial-p1"></div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-6 financial-p1-emp-img"></div>
      <div class="col-md-6 financial-p1-pos financial-p1-emp-desc-d">
        <div class="financial-p1-cont">
          <h3>MERQUELLANTAS GANA MEDALLA AL MÉRITO EMPRESARIAL</h3>
          <p>
            "Gracias a Fenalco, Valle por este reconocimiento, este logro es una
            bendición de Dios, alcanzada con toda la energía de un gran equipo.
            Gracias a Dios por estos 26 años de trabajo continuo, gracias a mi
            Señora e hijos, gracias a Jhon Jairo, mi socio, gracias a todos los
            funcionarios que han hecho posible hoy tener una compañía fuerte,
            sólida, sería, cumplidora de todos sus compromisos. Estoy feliz, por
            que este sueño que nació hace 26 años, hoy es una realidad. Somos
            una empresa que cree en este país, que cree en sus proveedores, que
            cree en su gente y que honra todos sus compromisos. Merquellantas un
            ejemplo que lo que pensemos, planifiquemos, ejecutemos y midamos se
            puede alcanzar". Sr. Jesús Maria Morales H. Presidente de
            Merquellantas.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<app-contacto></app-contacto>
<app-footer></app-footer>